module.exports = __webpack_public_path__ + "static/media/paypal.a400b251.png";